<template>
    <div>
        <footer class="footer footer-static footer-light">
            <p class="clearfix mb-0">
                <span class="float-right d-inline-block">2020 &copy; Pacto</span>
                <button class="btn btn-primary btn-icon scroll-top" type="button"><em class="bx bx-up-arrow-alt"></em></button>
            </p>
        </footer>
    </div>
</template>

<script>
    export default {
        
    }
</script>

